var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { CurrIcon } from './CurrIcon';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
var Option = /** @class */ (function (_super) {
    __extends(Option, _super);
    function Option(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectItemClick = function (e) {
            // 处理传递给回调函数的参数，目前只返回外部传递进来的 props。
            var _a = _this.props, onItemClick = _a.onItemClick, disable = _a.disable;
            if (!disable) {
                var optionProps_1 = {};
                // 处理传递给回调函数的参数：去掉 typeof 为 function
                Object.keys(_this.props).forEach(function (item) {
                    if (typeof _this.props[item] !== 'function') {
                        optionProps_1[item] = _this.props[item];
                    }
                });
                if (onItemClick)
                    onItemClick(optionProps_1, e);
            }
        };
        return _this;
    }
    Option.prototype.renderIcon = function () {
        var iconAtomics = ['absolute', 'top-0', 'right-0', 'mt-px-4', 'mr-px-12'];
        if (!this.props.selected)
            return null;
        return (React.createElement(SpanTag, { atomics: iconAtomics, autoPrefixedClassName: "option-icon" },
            React.createElement(CurrIcon, null)));
    };
    Option.prototype.render = function () {
        var itemAtomics = [
            'relative',
            'pt-px-5',
            'pl-px-8',
            'pb-px-5',
            'pr-px-30',
            'text-sm',
            'text-left',
        ];
        return (React.createElement(DivTag, { name: Option.NAME, title: this.props.title, className: "select-item " + (this.props.disabled ? 'disable' : '') + " " + (this.props.selected ? 'select-item-selected' : ''), atomics: itemAtomics, onClick: this.handleSelectItemClick },
            this.props.children,
            this.renderIcon()));
    };
    Option.NAME = 'option';
    return Option;
}(React.Component));
export { Option };
